export const selectDailyPlanList = (state) => state.dailyPlan.dailyPlans;
export const selectDailyPlanLoading = (state) => state.dailyPlan.loading;
export const selectDailyPlanError = (state) => state.dailyPlan.error;
export const selectDailyPlanCreateLoading = (state) => state.dailyPlan.createLoading;
export const selectDailyPlanCreateError = (state) => state.dailyPlan.createError;
export const selectDailyPlanCreateSuccess = (state) => state.dailyPlan.createSuccess;
export const selectDailyPlanUpdateLoading = (state) => state.dailyPlan.updateLoading;
export const selectDailyPlanUpdateError = (state) => state.dailyPlan.updateError;
export const selectDailyPlanUpdateSuccess = (state) => state.dailyPlan.updateSuccess;
export const selectDailyPlanDeleteLoading = (state) => state.dailyPlan.deleteLoading;
export const selectDailyPlanDeleteError = (state) => state.dailyPlan.deleteError;
export const selectDailyPlanDeleteSuccess = (state) => state.dailyPlan.deleteSuccess;